import { render } from "./error.vue?vue&type=template&id=38051c10&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=38051c10&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-38051c10"

export default script